<table mat-table [dataSource]="items">
  <ng-container matColumnDef="relative">
    <th mat-header-cell *matHeaderCellDef>Relative</th>
    <td mat-cell *matCellDef="let p">
      {{p.relative}}
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let p">
      {{p.name}}
    </td>
  </ng-container>
  <ng-container matColumnDef="starts">
    <th mat-header-cell *matHeaderCellDef>Starts</th>
    <td mat-cell *matCellDef="let p">
      {{p.realStart | date:'short'}}
    </td>
  </ng-container>
  <ng-container matColumnDef="ends">
    <th mat-header-cell *matHeaderCellDef>Ends</th>
    <td mat-cell *matCellDef="let p">
      {{p.realEnds | date:'short'}}
    </td>
  </ng-container>
  <ng-container matColumnDef="delayed">
    <th mat-header-cell *matHeaderCellDef>Delayed?</th>
    <td mat-cell *matCellDef="let p">
      <mat-icon>
        {{p.delayedStart !== undefined ? "check" : "close"}}
      </mat-icon>
    </td>
  </ng-container>
  <ng-container matColumnDef="cancelled">
    <th mat-header-cell *matHeaderCellDef>Cancelled?</th>
    <td mat-cell *matCellDef="let p">
      <button mat-icon-button type="button" (click)="toggleCancelled($event, p)"
              [color]="p.cancelled ? 'warn' : undefined"
              [matTooltip]="p.cancelled ? 'Mark active' : 'Mark cancelled'">
        <mat-icon>{{p.cancelled ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns" (click)="select(row)"></tr>
</table>
